import React, { ReactElement } from "react"
import "twin.macro"
const nextI18NextConfig = require("../../next-i18next.config.js").i18n
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Layout } from "../layouts/layout"
import MetaTags from "../components/metaTags"
import { GetStaticPropsContext } from "next"
import { Homepage } from "../components/homepage"

export async function getStaticProps(context: GetStaticPropsContext) {
  const translations = context.locale && (await serverSideTranslations(context.locale, undefined, nextI18NextConfig))

  return {
    props: {
      ...translations,
    },
    revalidate: 600,
  }
}

const Home = () => {
  return (
    <>
      <MetaTags />
      <Homepage />
    </>
  )
}

Home.getLayout = function getLayout(page: ReactElement) {
  return Layout(page, true)
}

export default Home
